import { ThreatCatalogApi, ThreatGroupApi, ThreatTierApi, TTPApi, GtMetaApi } from "@kdmanalytics/brm-knowledgebase";
import BrmApiClient from "services/brm/BrmApiClient";

export const threatCatalogApi = new ThreatCatalogApi(BrmApiClient.instance);
export const threatGroupApi = new ThreatGroupApi(BrmApiClient.instance);
export const threatTierApi = new ThreatTierApi(BrmApiClient.instance);
export const ttpApi = new TTPApi(BrmApiClient.instance);
export const gtMetaApi = new GtMetaApi(BrmApiClient.instance);
